/* eslint-disable no-alert */
/* eslint-disable no-unused-vars */
import React, { useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  Row, Col, Card, CardBody, CardTitle, Button,
} from 'reactstrap';
import { withTranslation } from 'react-i18next';

import toastr from 'toastr';
import 'toastr/build/toastr.min.css';

import {
  Formik, Field, Form, ErrorMessage,
} from 'formik';
import * as Yup from 'yup';

import BaseGrid from '../../../components/Common/BaseGrid';

import { post } from '../../../helpers/api_helper';
import { Can } from '../../../utilities/Can';
import ItemFieldset from '../../../components/Item/ItemFieldset';

function ItemSubs(props) {
  toastr.options = {
    positionClass: 'toast-top-right',
    newestOnTop: true,
  };

  const { t } = props;

  const [groupId, setGroupId] = useState(null);
  const [upd, setUpd] = useState(0);

  const save = async (values) => {
    try {
      const result = await post('/api/items/substitutes/associate', values);
      setGroupId(result.group_id);
      setUpd(upd + 1);
    } catch (error) {
      toastr.error(error.message, 'Error');
    }
  };

  const deleteSubstitute = async (sub, e) => {
    const btn = e.currentTarget;

    btn.disabled = true;
    btn.blur();
    btn.firstChild.classList.toggle('bx-spin');

    // eslint-disable-next-line no-restricted-globals
    const cnfrm = confirm(props.t(`Are you sure you want to delete substitute ${sub.item.part_number}?`));

    if (cnfrm) {
      try {
        await post('/api/items/substitutes/delete', { id: sub.id });

        toastr.success(`Deleted sub: ${sub.item.part_number}`, 'Success');
        setUpd(upd + 1);
      } catch (error) {
        toastr.error(error.message, 'Error');
      } finally {
        btn.disabled = false;
        btn.firstChild.classList.toggle('bx-spin');
      }
    }
  };

  const ValidationSchema = Yup.object().shape({
    items: Yup.array().of(
      Yup.object().shape({
        id: Yup.number().required(t('Item ID is required')),
      }),
    ),
  });

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Row>
          <Col xl="4">
            <Card>
              <CardBody>
                <CardTitle className="h4">{props.t('Item Substitutions')}</CardTitle>

                <Can i="see" this="Subs">
                  <Formik
                    enableReinitialize
                    initialValues={{ items: [] }}
                    validationSchema={ValidationSchema}
                    onSubmit={(values) => {
                      save(values);
                    }}
                  >
                    {({
                      touched, errors, values, setFieldValue,
                    }) => (
                      <Form className="mt-3" id="ItemSubstituteForm" autoComplete="off">
                        <ItemFieldset />

                        <Button type="submit" color="primary" className="btn-soft-primary mt-3">{props.t('Save')}</Button>
                      </Form>
                    )}
                  </Formik>
                </Can>

                <Can not i="see" this="Subs"><p>{props.t('Unauthorized')}</p></Can>
              </CardBody>
            </Card>
          </Col>

          <Col xl="8">
            {groupId !== null && (
              <Card>
                <CardBody>
                  <CardTitle className="h4">{props.t('Matched Substitutes')}</CardTitle>
                  <BaseGrid
                    url={`/api/items/substitutes/group/${groupId}`}
                    shouldUpdate={upd}
                    config={
                    {
                      columns: {
                        thumb: {
                          label: '',
                          image: {
                            src: (sub) => (`/api/items/thumbnail/${sub.item.id}`),
                            class: 'rounded',
                            style: { maxHeight: '5rem', maxWidth: '5rem' },
                          },
                          translate: false,
                        },
                        id: {
                          label: props.t('ID'),
                          sort: false,
                          format: (x, e) => e.item.id,
                        },
                        manufacturer: {
                          label: props.t('Manufacturer'),
                          sort: false,
                          format: (x, e) => e.item.manufacturer,
                        },
                        part_number: {
                          label: props.t('Part Number'),
                          sort: false,
                          format: (x, e) => e.item.part_number,
                        },
                        tags: {
                          label: 'Tags',
                          format: (x, e) => (e.item.tags.map((r) => (r.label))),
                          badges: {
                            class: 'bg-info bg-soft text-dark p-2',
                          },
                        },
                        actions: {
                          label: props.t('Actions'),
                          actions: [
                            {
                              key: 'delete',
                              icon: 'mdi mdi-delete',
                              class: 'btn btn-sm btn-soft-danger',
                              alt: props.t('Delete'),
                              click: deleteSubstitute,
                            },
                          ],
                        },
                      },
                      pagination: {
                        sort: 'id',
                        direction: 'desc',
                        perPage: 30,
                      },
                    }
                    }
                  />
                </CardBody>
              </Card>
            )}
          </Col>
        </Row>
      </div>
    </div>
  );
}

ItemSubs.propTypes = {
  // eslint-disable-next-line react/require-default-props
  t: PropTypes.any,
};

export default connect(() => ({

}), {})(withTranslation()(ItemSubs));
